module.exports = __webpack_public_path__ + "static/media/user-checkin-light.1b4fba82.svg";